
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class LabourPriceListDetailsGrid extends Serenity.EntityGrid<LabourPriceListDetailsRow, any> {
        protected getColumnsKey() { return 'OMS.LabourPriceListDetails'; }
        protected getDialogType() { return LabourPriceListDetailsDialog; }
        protected getIdProperty() { return LabourPriceListDetailsRow.idProperty; }
        protected getInsertPermission() { return LabourPriceListDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return LabourPriceListDetailsRow.localTextPrefix; }
        protected getService() { return LabourPriceListDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}